import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBulbComponent } from "./med-icon-bulb.component";

@NgModule({
  declarations: [
    MedIconBulbComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBulbComponent,
  ],
})
export class MedIconBulbModule { }
